export default "__VITE_ASSET__B1X$qEVJ__"